import { render, staticRenderFns } from "./WidgetFormItem.vue?vue&type=template&id=77c110a9&"
import script from "./WidgetFormItem.vue?vue&type=script&lang=js&"
export * from "./WidgetFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports